"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Corpo = void 0;
var react_1 = __importDefault(require("react"));
var Tipografia_1 = require("../Tipografia");
var GradacaoNeutros_1 = __importDefault(require("../../Cores/GradacaoNeutros "));
var Corpo = function (_a) {
    var _b = _a.tag, tag = _b === void 0 ? "div" : _b, _c = _a.negrito, negrito = _c === void 0 ? 400 : _c, _d = _a.cor, cor = _d === void 0 ? GradacaoNeutros_1.default.PretoMU900 : _d, conteudo = _a.conteudo, _e = _a.overline, overline = _e === void 0 ? false : _e, tipo = _a.tipo, _f = _a.italico, italico = _f === void 0 ? false : _f, _g = _a.sublinhado, sublinhado = _g === void 0 ? false : _g, _h = _a.children, children = _h === void 0 ? null : _h, corOnHover = _a.corOnHover, title = _a.title, style = _a.style, onClick = _a.onClick;
    var tamanhoPadrao = {
        "body1": 16,
        "body2": 14,
        "body3": 12,
        "button1": 14,
        "button2": 12,
        "label1": 14,
        "label2": 12,
        "label3": 10,
        "caption": 12,
        "breadcrumb": 12,
        "overline": 10
    };
    var lineHeightPadrao = {
        "body1": 24,
        "body2": 20,
        "body3": 18,
        "button1": 16,
        "button2": 16,
        "label1": 16,
        "label2": 16,
        "label3": 14,
        "caption": 20,
        "breadcrumb": 14,
        "overline": 14
    };
    var letterSpacingPadrao = {
        "body1": "0",
        "body2": "0",
        "body3": "0",
        "button1": "1.5px",
        "button2": "1px",
        "label1": "1px",
        "label2": "1px",
        "label3": "0.25px",
        "caption": "0.25px",
        "breadcrumb": "0.25px",
        "overline": "1.5px"
    };
    var getEspacamentoCaractere = function (tipo) {
        if (!tipo || "0" == letterSpacingPadrao[tipo.toLowerCase()])
            return "normal";
        else
            return letterSpacingPadrao[tipo.toLowerCase()];
    };
    var lineHeight = (tipo) ? "".concat(lineHeightPadrao[tipo.toLowerCase()], "px") : "20px";
    var fontWeight = (negrito) ? negrito : 400;
    var isOverline = (tipo == "overline") || overline ? true : false;
    var estiloCursor = onClick || tipo == "button1" || tipo == "button2" ? "pointer" : "default";
    return (react_1.default.createElement(Tipografia_1.Tipografia, { tag: tag, label: children !== null && children !== void 0 ? children : conteudo, size: tamanhoPadrao[tipo.toLowerCase()], overline: isOverline, cor: cor, sublinhado: sublinhado, espacamentoLinha: lineHeight, espacamentoCaractere: getEspacamentoCaractere(tipo), italico: italico, negrito: fontWeight, corOnHover: corOnHover, title: title, style: __assign({ cursor: estiloCursor }, style), onClick: onClick }));
};
exports.Corpo = Corpo;
